export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/5511951063038"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform duration-300 cursor-pointer group"
      aria-label="Falar no WhatsApp"
    >
      <i className="ri-whatsapp-fill text-3xl text-white"></i>
      <span className="absolute right-full mr-4 bg-[#0047AB] text-white px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 shadow-lg">
        Fale Conosco!
      </span>
    </a>
  );
}